<template>
  <div class="bg_map d-flex justify-center">
    <div class="overlay_context">
      <v-card
        class="pa-3 overlay_card rounded-lg d-flex align-center"
        color="#23003a"
      >
        <a href="https://temanbakat.id/" style="text-decoration: none">
          <img
            src="../assets/img/logo-teman-bakat.png"
            height="60px"
            class="mr-3"
            alt="teman bakat"
          />
        </a>
        <div
          class="pa-2 white--text"
          style="border-left: 1px solid #fafafa; height: 100%; border-radius: 0"
        >
          <p class="small_txt mb-0" v-if="!objOrder.order3">
            Mulai perjanlananmu dengan <i>The Journey</i> dan dapatkan bonus
            50.000 poin
          </p>
          <p class="small_txt mb-0" v-if="objOrder.order3 && !objOrder.order8">
           Registrasi sekarang untuk klaim 30.000 poin!
          </p>
          <p class="small_txt mb-0" v-if="objOrder.order8">

           Registrasi sekarang untuk klaim 50.000 poin!
          </p>
        </div>
      </v-card>
    </div>
    <div class="breakpoint d-flex justify-center align-center">
      <div class="map">
        <img src="../assets/img/map.png" class="img-map" alt="map" />
        <div class="pin">
          <!-- PIN COMING SOON -->
          <div class="pin_coming_soon" v-if="objOrder.order8">
            <div class="coming_soon_img">
              <img :src="comingSoon" height="33px" alt="" />
            </div>
            <img
              src="../assets/img/pin_island_arrow.png"
              class="img-pin"
              alt="pin journey teman bakat"
            />
          </div>
          <!-- PIN 8 -->
          <div class="pin8">
            <div class="status-ico" v-if="objOrder.order8">
              <router-link
                :to="`/result/${objOrder.order8.journey
                  .replace(/\s/g, '')
                  .toLowerCase()}`"
              >
                <div>
                  <img :src="objOrder.order8.img" height="35px" alt="" />
                </div>
              </router-link>
            </div>
            <img
              src="../assets/img/pin_island.png"
              class="img-pin"
              v-if="objOrder.order8"
              alt="pin journey teman bakat"
            />
            <img
              @click="dialogSelectJourney = true"
              src="../assets/img/pin_island_arrow.png"
              v-if="objOrder.order7 && !objOrder.order8"
              class="img-pin"
              alt="pin journey teman bakat"
            />
          </div>
          <!-- PIN 7 -->
          <div class="pin7">
            <div class="status-ico" v-if="objOrder.order7">
              <router-link
                :to="`/result/${objOrder.order7.journey
                  .replace(/\s/g, '')
                  .toLowerCase()}`"
              >
                <div>
                  <img :src="objOrder.order7.img" height="35px" alt="" />
                </div>
              </router-link>
            </div>
            <img
              src="../assets/img/pin_island.png"
              v-if="objOrder.order7"
              class="img-pin"
              alt="pin journey teman bakat"
            />
            <img
              @click="dialogSelectJourney = true"
              src="../assets/img/pin_island_arrow.png"
              v-if="objOrder.order6 && !objOrder.order7"
              class="img-pin"
              alt="pin journey teman bakat"
            />
          </div>
          <!-- PIN 6 -->
          <div class="pin6">
            <div class="status-ico" v-if="objOrder.order6">
              <router-link
                :to="`/result/${objOrder.order6.journey
                  .replace(/\s/g, '')
                  .toLowerCase()}`"
              >
                <div>
                  <img :src="objOrder.order6.img" height="35px" alt="" />
                </div>
              </router-link>
            </div>
            <img
              v-if="objOrder.order6"
              src="../assets/img/pin_island.png"
              class="img-pin"
              alt="pin journey teman bakat"
            />
            <img
              @click="dialogSelectJourney = true"
              src="../assets/img/pin_island_arrow.png"
              v-if="objOrder.order5 && !objOrder.order6"
              class="img-pin"
              alt="pin journey teman bakat"
            />
          </div>
          <!-- PIN 5 -->
          <div class="pin5">
            <div class="status-ico" v-if="objOrder.order5">
              <router-link
                :to="`/result/${objOrder.order5.journey
                  .replace(/\s/g, '')
                  .toLowerCase()}`"
              >
                <img :src="objOrder.order5.img" height="35px" alt="" />
              </router-link>
            </div>
            <img
              v-if="objOrder.order5"
              src="../assets/img/pin_island.png"
              class="img-pin"
              alt="pin journey teman bakat"
            />
            <img
              @click="dialogSelectJourney = true"
              src="../assets/img/pin_island_arrow.png"
              v-if="objOrder.order4 && !objOrder.order5"
              class="img-pin"
              alt="pin journey teman bakat"
            />
          </div>
          <!-- PIN 4 -->
          <div class="pin4">
            <div class="status-ico" v-if="objOrder.order4">
              <router-link
                :to="`/result/${objOrder.order4.journey
                  .replace(/\s/g, '')
                  .toLowerCase()}`"
              >
                <div>
                  <img :src="objOrder.order4.img" height="35px" alt="" />
                </div>
              </router-link>
            </div>
            <img
              v-if="objOrder.order4"
              src="../assets/img/pin_island.png"
              class="img-pin"
              alt="pin journey teman bakat"
            />
            <img
              @click="dialogSelectJourney = true"
              src="../assets/img/pin_island_arrow.png"
              v-if="objOrder.order3 && !objOrder.order4"
              class="img-pin"
              alt="pin journey teman bakat"
            />
          </div>
          <!-- PIN 3 -->
          <div class="pin3">
            <div
              class="status-ico"
              v-if="objOrder.order3"
              @click="dialogSelectJourney = true"
            >
              <router-link
                :to="`/result/${objOrder.order3.journey
                  .replace(/\s/g, '')
                  .toLowerCase()}`"
              >
                <div>
                  <img :src="objOrder.order3.img" height="35px" alt="" />
                </div>
              </router-link>
            </div>
            <img
              src="../assets/img/pin_island.png"
              v-if="objOrder.order3"
              class="img-pin"
              alt="pin journey teman bakat"
            />
            <img
              @click="dialogSelectJourney = true"
              src="../assets/img/pin_island_arrow.png"
              v-if="objOrder.order2 && !objOrder.order3"
              class="img-pin"
              alt="pin journey teman bakat"
            />
          </div>
          <!-- PIN 2 -->
          <div class="pin2">
            <div class="status-ico" v-if="objOrder.order2">
              <router-link
                :to="`/result/${objOrder.order2.journey
                  .replace(/\s/g, '')
                  .toLowerCase()}`"
              >
                <div>
                  <img :src="objOrder.order2.img" height="35px" alt="" />
                </div>
              </router-link>
            </div>
            <img
              src="../assets/img/pin_island.png"
              v-if="objOrder.order2"
              class="img-pin"
              alt="pin journey teman bakat"
            />
            <img
              @click="dialogSelectJourney = true"
              src="../assets/img/pin_island_arrow.png"
              v-if="objOrder.order1 && !objOrder.order2"
              class="img-pin"
              alt="pin journey teman bakat"
            />
          </div>
          <!-- PIN 1 -->
          <div class="pin1">
            <img
              @click="dialogSelectJourney = true"
              src="../assets/img/pin_island_arrow.png"
              class="img-pin"
              v-if="!objOrder.order1"
              alt="pin journey teman bakat"
            />
            <div class="status-ico" v-if="objOrder.order1">
              <router-link
                :to="`/result/${objOrder.order1.journey
                  .replace(/\s/g, '')
                  .toLowerCase()}`"
              >
                <div>
                  <img :src="objOrder.order1.img" height="35px" alt="" />
                </div>
              </router-link>
            </div>
            <div>
              <img
                src="../assets/img/pin_island.png"
                v-if="objOrder.order1"
                class="img-pin"
                alt="pin journey teman bakat"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <SelectJourney
        :dialogSelectJourney="dialogSelectJourney"
        @close="closeDialog"
      />
    </div>
  </div>
</template>

<script>
import SelectJourney from "../components/journey/Modal/selectJourney.vue";
export default {
  components: { SelectJourney },
  name: "Roadmap",
  data() {
    return {
      dialogSelectJourney: false,
      objOrder: {},
      comingSoon: require("../assets/img/coming_soon.jpeg"),
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
      this.orderJourney();
    }, 100);
  },
  methods: {
    orderJourney() {
      let completed = JSON.parse(localStorage.getItem("completed"));
      for (let i = 1; i <= 10; i++) {
        this.objOrder[`order${i}`] = null;
      }
      if (completed) {
        completed.forEach((x) => {
          this.objOrder[`order${x.order}`] = x;
        });
      }
      this.objOrder = Object.assign({}, this.objOrder, this.objOrder);
    },
    closeDialog() {
      this.dialogSelectJourney = false;
    },
  },
};
</script>

<style scoped></style>
